const state = {
	cancelTokenArr: [] // 取消请求token数组
}

const mutations = {
	pushToken(state, payload) {
		state.cancelTokenArr.push(payload.cancelToken)
	},
	clearToken({ cancelTokenArr }) {
		cancelTokenArr.forEach(item => {
			item('路由跳转取消请求')
		})
		cancelTokenArr = []
	}
}

export default {
	namespaced: true,
	state,
	mutations
}

